import {
	TASK,
	type HierarchyParent,
} from '@atlassian/jira-business-common/src/common/types/hierarchy.tsx';
import { useFilteredViewContextInput } from '@atlassian/jira-business-filters/src/controllers/default-query-input/index.tsx';

type HierarchyConfig = {
	showFlatList: boolean;
	hierarchyParent?: HierarchyParent;
};

export const useHierarchyConfig = (): HierarchyConfig => {
	const { isFiltering } = useFilteredViewContextInput({ view: 'list' });

	const hierarchyParent = !isFiltering ? TASK : undefined;

	return {
		showFlatList: isFiltering,
		hierarchyParent,
	};
};
